import { render, staticRenderFns } from "./FilterByCustomerGroup.vue?vue&type=template&id=9a5f4f02&"
import script from "./FilterByCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./FilterByCustomerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
